// Libarary
import { Injectable } from '@angular/core';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class CppReportService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }
  public accountName: string;

  // GetSulfurZincPricingReportsData
  public getSulfurZincPricingReportData() {
    return this.networkService.getRequest(this.configService.getSulfurZincPricingReportData());
  }

  // GetAMSPricingReportData
  public getAMSPricingReportData() {
    return this.networkService.getRequest(this.configService.getAMSPricingReportData());
  }
}
